import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useCMSData } from "app/hooks/useCMSData";
import { colors, customBreakpointsMax } from "app/theme";
import { getHeaderButtonItems } from "app/components/header/sub-components/buttons/data";
import { HeaderExpandedViewProps } from "app/components/header/sub-components/expanded-view/data";
import { HeaderSignInView } from "app/components/header/sub-components/expanded-view/views/signin";
import { HeaderExplorerView } from "app/components/header/sub-components/expanded-view/views/explorer";
import { HeaderPublisherView } from "app/components/header/sub-components/expanded-view/views/publisher";
import { HeaderResourcesView } from "app/components/header/sub-components/expanded-view/views/resources";

export const HeaderExpandedView: React.FC<HeaderExpandedViewProps> = (
  props: HeaderExpandedViewProps
) => {
  const cmsData = useCMSData({ returnData: true });

  const HEADER_BUTTON_ITEMS = React.useMemo(
    () => getHeaderButtonItems(cmsData),
    [cmsData]
  );

  const view = React.useMemo(() => {
    switch (props.activeButton) {
      case HEADER_BUTTON_ITEMS[0].key:
        return <HeaderExplorerView />;
      case HEADER_BUTTON_ITEMS[1].key:
        return <HeaderPublisherView />;
      case HEADER_BUTTON_ITEMS[2].key:
        return <HeaderResourcesView />;
      case HEADER_BUTTON_ITEMS[4].key:
        return <HeaderSignInView />;
      default:
        return null;
    }
  }, [props.activeButton, HEADER_BUTTON_ITEMS]);

  return (
    <Box
      sx={{
        left: 0,
        zIndex: 1,
        width: "100vw",
        position: "absolute",
        background: colors.secondary.lightGrey,
        borderBottom: `1px solid ${colors.secondary.iconGray}`,
      }}
    >
      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          [customBreakpointsMax.tablet]: {
            padding: "0 40px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            padding: "20px 0",
            flexDirection: "column",
            background: colors.secondary.lightGrey,
          }}
        >
          {view}
        </Box>
      </Container>
    </Box>
  );
};
